import { Base } from "./base";

export class CustomPermission extends Base {
  /**
   * @description List Custom Permission API function
   * @param {object} filterParams
   * @returns {Promise<Response>}
   */
  list(filterParams) {
    const url = new URL(this._getFullURL("/custom-permission"));
    url.search = new URLSearchParams(filterParams).toString();
    return fetch(url, this._generateRequestBody({}));
  }
}
